import * as dto from '@epicuro-next/data/baskets-dto';
import { Maybe } from 'graphql-api/baskets-api-interfaces';

export function findBasketAccount(
  { basketAccountId }: dto.Item,
  basketAccounts: dto.BasketAccountMap,
) {
  return basketAccounts[basketAccountId];
}

/**
 * Create map for basketAccounts.
 */
export function getBasketAccountsMap(
  basketAccounts: dto.BasketAccount[],
): dto.BasketAccountMap {
  return basketAccounts.reduce((result, item) => {
    return {
      ...result,
      [item.basketAccountId]: item,
    };
  }, {} as dto.BasketAccountMap);
}

/**
 * Get Shipping Options.
 */
export function getShippingOptions(
  basketAccounts: dto.BasketAccount[],
): dto.ShippingOption[] {
  return basketAccounts
    ? basketAccounts.find((basketAccount) => basketAccount.shippingOptions)
        ?.shippingOptions ?? []
    : [];
}

export function getAlternativeAddress(
  basketAccounts: dto.BasketAccount[],
): Maybe<dto.AlternativeAddress> {
  return (
    // check for address near alternativeAddress, as alternative address is also used for exposing deleted addresses info
    basketAccounts.find(({ alternativeAddress, address }) =>
      Boolean(alternativeAddress && address),
    )?.alternativeAddress || null
  );
}
